<template>
  <ul
    ref="statelineRef"
    class="rt-stateline"
    :class="computedStatelineClass"
  >
    <slot></slot>
    <rt-button-more
      v-if="!roll&&direction === 'vertical' && steps.length > displayCount"
      :expanded-suffix-icon="computedShowSuffixIcon"
      :collapsed-suffix-icon="computedShowSuffixIcon"
      :button-color="buttonColor"
      @change="changeExpand"
    ></rt-button-more>
  </ul>
</template>

<script>
import RtButtonMore from '../button/rtButtonMore.vue';
import xpcConfig from '../../config';
export default {
  name: 'RtStateline',
  components: {
    RtButtonMore
  },
  props: {
    direction: {
      type: String,
      default: 'vertical',
      validator: val => {
        return ['horizontal', 'vertical'].includes(val);
      }
    },
    displayCount: {
      type: Number,
      default: 4
    },
    // “查看更多”按钮是否支持点击事件
    moreClick: Boolean,
    // 状态戳描边
    border: {
      type: Boolean,
      default: null
    },
    // 节点排列方向是否倒叙
    reverse: {
      type: Boolean,
      default: false
    },
    // 滚动查看
    roll: {
      type: Boolean,
      default: false
    },
    // 均分布局
    equal: {
      type: Boolean,
      default: false
    },
    // 按钮类型
    buttonColor: {
      type: String,
      default: 'neutral-secondary'
    },
    // 是否显示按钮图标
    showSuffixIcon: {
      type: Boolean,
      default: true
    },
    // 垂直均分状态高度
    itemHeight: {
      type: Number
    },
    // 水平均分状态宽度
    itemWidth: {
      type: Number
    }
  },
  data () {
    return {
      steps: []
    };
  },
  computed: {
    computedBorder () {
      return this.border === null ? xpcConfig.get('stateline.border') : this.border
    },
    computedStatelineClass () {
      let classList = [];
      if (this.direction) {
        classList.push(`rt-stateline--${this.direction}`)
      }
      if (this.equal) {
        classList.push(`rt-xpc-stateline-equal`)
      }
      return classList
    },
    computedShowSuffixIcon () {
      if (this.showSuffixIcon) {
        return 'rt-base-arrow-right-lined'
      }
      return ''
    }
  },
  watch: {
    current (newVal, oldVal) {
      this.$emit('change', newVal, oldVal);
    },
    steps (steps) {
      if (!this.roll) {
        steps.forEach((child, index) => {
          child.index = index;
          if (this.direction === 'vertical') {
            if (index > this.displayCount - 1) {
              child.isExpand = false;
            }
            if (index > this.displayCount - 2) {
              child.isTailExpand = false
            }
          }
        });
      }
    },
    reverse: {
      handler (newVal) {
        if (newVal) {
          this.$slots.default = [...this.$slots.default].reverse();
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.roll) {
        this.scroll();
      }
      if (this.itemHeight !== '') {
        let statelineEl = this.$refs['statelineRef'];
        let statelineItemEl = statelineEl.querySelectorAll('.rt-stateline-item');
        statelineItemEl.forEach((item) => {
          item.style.height = `${this.itemHeight}px`
        })
      }
      if (this.itemWidth !== '') {
        let statelineEl = this.$refs['statelineRef'];
        let statelineItemEl = statelineEl.querySelectorAll('.rt-stateline-item');
        statelineItemEl.forEach((item) => {
          item.style.width = `${this.itemWidth}px`
        })
      }
    });
  },
  methods: {
    changeExpand (isExpand) {
      if (this.moreClick) {
        let textDom = this.$el.querySelector('.rt-xpc-button-more .rt-button-text');

        if (textDom) {
          this.$emit('click');
          textDom.innerText = this.$tx('查看更多', 'xpc.common.seemore');
          return;
        }
      }
      this.steps.forEach((child, index) => {
        if (index > this.displayCount - 1) {
          child.isExpand = isExpand;
        }
        if (index > this.displayCount - 2) {
          child.isTailExpand = isExpand;
        }
      });
    },
    scroll () {
      if (this.$refs.statelineRef) {
        let currentIndex;
        this.steps.forEach((item, index) => {
          if (item && item.status) {
            currentIndex = index;
          }
        });
        this.contentScrollTo(currentIndex);
      }
    },
    contentScrollTo (index) {
      const contentEl = this.$refs['statelineRef'];
      const contentItems = contentEl && contentEl.querySelectorAll('.rt-stateline-item');
      let h = 16;
      for (let i = 0; i < index; i++) {
        let itemEl = contentItems[i];
        const { height } = itemEl.getBoundingClientRect();
        h += height;
        if (i === index - 1) {
          h += height / 2
        }
      }
      const contentHeight = contentEl.getBoundingClientRect().height;
      this.scrollTop(contentEl, h - (contentHeight / 2))
    },
    /**
     * @private
     * 平滑滚动元素
     * @param {Element} el 要滚动的元素
     * @param {Number} top 滚动的高度
     */
    scrollTop (el, top) {
      el.scrollTo({ top });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtStateline.vue?87194258